import { useAnalytics } from '@psyomics/ui-common';
import { Model } from 'survey-react-ui';

type CreateSurveyEventHandlersProps = {
  analytics: ReturnType<typeof useAnalytics>;
  invitePublicId: string;
  organisationCode?: string | null;
  serviceCode?: string | null;
  updateSurvey: (survey: Model, complete: boolean, forceUpload?: boolean) => Promise<void>;
};

const createSurveyEventHandlers = ({
  analytics,
  invitePublicId,
  serviceCode,
  organisationCode,
  updateSurvey,
}: CreateSurveyEventHandlersProps) => ({
  onPageChange: (survey: Model) => {
    if (survey.currentPage) {
      analytics.trackEvent({
        event: 'questionnaire_page_started',
        properties: {
          invite: invitePublicId,
          name: survey.currentPage.name,
          ...(serviceCode && { service: serviceCode }),
        },
        captureOptions: organisationCode ? { $groups: { organisation: organisationCode } } : undefined,
      });
    }
    updateSurvey(survey, false, true);
  },
  onComplete: (survey: Model) => {
    analytics.trackEvent({
      event: 'questionnaire_completed',
      properties: { invite: invitePublicId, ...(serviceCode && { service: serviceCode }) },
      captureOptions: organisationCode ? { $groups: { organisation: organisationCode } } : undefined,
    });
    updateSurvey(survey, true, true);
  },
  onValueChange: (survey: Model, options: { name: string }) => {
    const q = survey.getQuestionByName(options.name);
    const type = q.getType();
    if (type !== 'expression') {
      analytics.trackEvent({
        event: 'question_answered',
        properties: { invite: invitePublicId, name: options.name, ...(serviceCode && { service: serviceCode }) },
        captureOptions: organisationCode ? { $groups: { organisation: organisationCode } } : undefined,
      });
    }

    updateSurvey(survey, false);
  },
});

export { createSurveyEventHandlers };
